import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge does not read Tailwind config / @theme. Custom `text-xxs`
 * (from @theme in index.css) was being merged with `text-*` colors; only one
 * survived. Register `xxs` as a font-size token so size + color can coexist.
 *
 * @see https://github.com/dcastil/tailwind-merge/issues/418
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['xxs'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
